module.exports = __webpack_public_path__ + "img/hktcmbg.cf76786e.jpg";